import { render, staticRenderFns } from "./administrationColumnsDevices.vue?vue&type=template&id=4c13a5eb&"
import script from "./administrationColumnsDevices.vue?vue&type=script&lang=js&"
export * from "./administrationColumnsDevices.vue?vue&type=script&lang=js&"
import style0 from "./administrationColumnsDevices.vue?vue&type=style&index=0&id=4c13a5eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports